import { createApp } from "vue";
import App from "./App.vue";
import { setupVab } from "~/library";
import { setupI18n } from "@/i18n";
import { setupStore } from "@/store";
import { setupRouter } from "@/router";
import "@/fonts/font.scss";
import VideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import moduleCard from "@/components/moduleCard.vue";
import moduleTitle from "@/components/moduleTitle.vue";
import noData from "@/components/noData.vue";
import vue3TreeOrg from "vue3-tree-org";
import "vue3-tree-org/lib/vue3-tree-org.css";
import VMdPreview from "@kangc/v-md-editor/lib/preview";
import "@kangc/v-md-editor/lib/style/preview.css";
import githubTheme from "@kangc/v-md-editor/lib/theme/github.js";
import "@kangc/v-md-editor/lib/theme/style/github.css";
// highlightjs
import hljs from "highlight.js";
import createMermaidPlugin from "@kangc/v-md-editor/lib/plugins/mermaid/cdn";
import "@kangc/v-md-editor/lib/plugins/mermaid/mermaid.css";
import "@/assets/font/title.css";
import "@/assets/font/Number.css";
import "@/assets/font/text.css";
VMdPreview.use(githubTheme, {
    Hljs: hljs,
    config: {
        toc: {
            includeLevel: [1, 2, 3, 4, 5, 6],
        },
        markdown: {
            breaks: true,
            linkify: true,
            typographer: true,
            html: true,
            tables: true,
            tasklists: true,
            footnotes: true,
            deflist: true,
            strikethrough: true,
            sup: true,
            sub: true,
            mark: true,
            ins: true,
            abbr: true,
            emoji: true,
            // 允许嵌入图片、视频、音频等
            image: true,
            video: true,
            audio: true,
            // 允许自动识别 url
            autolink: true,
            // 允许代码块高亮
            highlight: true,
            // 允许引用
            blockquote: true,
            // 允许有序/无序列表
            list: true,
            // 允许标题
            heading: true,
            // 允许分割线
            hr: true,
            // 允许内联代码
            code: true,
            // 允许表格对齐
            align: true,
            // 允许下划线
            underline: true,
            // 允许上标下标
            subscript: true,
            superscript: true,
            // 允许数学公式
            math: true,
            // 允许流程图
            mermaid: true,
        },
        highlight: {
            theme: "github",
            lineNumbers: true,
            lineHighlight: true,
        },
        math: {
            engine: "katex",
            inlineMath: [
                ["$", "$"],
                ["\\(", "\\)"],
            ],
            blockMath: [
                ["$$", "$$"],
                ["\\[", "\\]"],
            ],
        },
        chart: true,
        // 启用 mermaid 流程图解析
        mermaid: true,
        // 其它图表功能保留
        sequence: true,
        gantt: true,
        class: true,
        state: true,
        pie: true,
        relationship: true,
        journey: true,
    },
});
// 注册 mermaid 插件
VMdPreview.use(createMermaidPlugin);
const app = createApp(App);
app.use(VMdPreview);
app.use(vue3TreeOrg);
app.component("moduleCard", moduleCard); //模块盒子
app.component("moduleTitle", moduleTitle); //模块标题
app.component("noData", noData); //暂无数据
/**
 * 统一设置echarts主题
 */
import * as echarts from "echarts";
import setTheme from "@/assets/json/echarts-motif.json";
echarts.registerTheme("motif", setTheme);
setupVab(app);
setupI18n(app);
setupStore(app);
setupRouter(app)
    .isReady()
    .then(() => app.use(VideoPlayer).mount("#app"));
